import styled from 'styled-components'
import breakpoint from '../theme/breakpoint'
import space from '../theme/space'

export const HorizontalScroll = styled.div`
  position: relative;
  margin: 0 -1.45rem;

  @media (min-width: ${breakpoint.xl}) {
    & > div:last-of-type {
      display: none;
    }
  }
`

export const HorizontalScrollInner = styled.div`
  display: flex;
  overflow-x: auto;
  align-items: flex-start;
  padding: 0;
  @media (min-width: ${breakpoint.lg}) {
    padding: 0 ${space.xl6};
  }
  @media (min-width: ${breakpoint.xl}) {
    padding: 0 ${space.xl6} 0 ${space.lg};
  }
  &::-webkit-scrollbar {
    display: none;
  }
`
